import React, { useMemo } from 'react';
import { useMediaQuery } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Header from 'components/Header/Header';
import LeftNavigation from 'components/LeftNavigation/LeftNavigation';
import { useCurrentLocationIsDealer } from 'hooks/useCurrentLocationIsDealer';
import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics';
import { AnalyticsAction, AnalyticsCategory } from 'hooks/useGoogleAnalytics/types';

const useStyles = makeStyles(() =>
  createStyles({
    privateRouteContainer: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      overflowX: 'auto',
    },
    appContent: {
      flex: 'auto',
      display: 'flex',
      height: 'calc(100% - 4rem)',
      overflow: 'auto',
    },
  }),
);

export interface PrivateWrapperProps {}

function PrivateWrapper(props: React.PropsWithChildren<PrivateWrapperProps>) {
  const { children } = props;
  const classes = useStyles();
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('xs'));

  const googleAnalyticsUtils = useGoogleAnalytics();
  const isDealer = useCurrentLocationIsDealer();

  useMemo(() => {
    googleAnalyticsUtils.event({
      category: AnalyticsCategory.VIEWPORT,
      action: mobileView ? AnalyticsAction.USING_MOBILE_VERSION : AnalyticsAction.USING_DESKTOP_VERSION,
      isDealer: !!isDealer,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileView, isDealer]);

  return (
    <div className={classes.privateRouteContainer}>
      <CssBaseline />
      <div style={{ height: '4rem' }}>
        <Header />
      </div>
      <div className={classes.appContent}>
        {mobileView && <LeftNavigation />}
        <main className={classes.content}>{children}</main>
      </div>
    </div>
  );
}

export default PrivateWrapper;
